
// 是否显示判断
export const isShowSmtParams = (smtParams, pcbParams) => ({
  // 生产数量类型
  number_type:[1,2].includes(smtParams.custom_pcb_ban) && [1, 2].includes(pcbParams.units)
})
const formatPadNumber = (smt_params)=>{
  const { patch_pad_number,patch_pad_number_bot, patch_pad_number_top,plug_number } = smt_params.smt_order || {}
  if(smt_params.number<=100){
    const single_or_double_technique = smt_params.single_or_double_technique
    const statMap = { 2: patch_pad_number, 0: patch_pad_number_bot, 1: patch_pad_number_top }
    const pad_number = statMap[+single_or_double_technique]
    if(pad_number!==null||pad_number!==undefined){
      if([0,1].includes(+pad_number)){
        smt_params['patch_pad_number']=1
      }else{
        smt_params['patch_pad_number']=pad_number
      }
    }else{
      smt_params['patch_pad_number']=1
    }
    if([0,1].includes(+plug_number)){
      smt_params['plug_number']=1
    }else{
      smt_params['plug_number']=plug_number
    }
  }else{
    smt_params['patch_pad_number']=1
    smt_params['plug_number']=1
  }
}
// SMT参数格式化
export const formatSmtParams = (smtParams, otherParams = {}) => {
  const params = { ...smtParams, ...otherParams }
  const { order_info, address, invoice, pcbParams: pcb_params, ...smt_params } = params

  // // 单片贴片点数：用户不填时，默认为1
  // smt_params.patch_pad_number = smt_params.patch_pad_number || 1
  // // 单片插件点数：用户不填时，焊接插件料 === 否，默认为0；焊接插件料 === 是，默认为1
  // smt_params.plug_number = !smt_params.is_plug ? 0 : smt_params.plug_number || 1
  // 板面清洁：焊接插件料 === 否，默认为0
  smt_params.is_layout_cleaning = !smt_params.is_plug ? 0 : smt_params.is_layout_cleaning

  // PCB 自己提供
  if (smt_params.custom_pcb_ban == 3) {
    // 拼板数
    smt_params.splicing_number = (smt_params.pcb_ban_x || 1) * (smt_params.pcb_ban_y || 1)
  } else {
    // 拼板数
    smt_params.splicing_number = ''
    // PCB拼板尺寸 长
    smt_params.pcb_ban_width = ''
    // PCB拼板尺寸 宽
    smt_params.pcb_ban_height = ''
    // PCB拼板规则 x方向个数
    smt_params.pcb_ban_x = ''
    // PCB拼板规则 y方向个数
    smt_params.pcb_ban_y = ''
  }

  // PCB全贴数量
  if (smt_params.number_for_pcb || smt_params.number_for_pcb === 0) {
    smt_params.number = smt_params.number_for_pcb
  }
  if(smt_params.smt_order){
   formatPadNumber(smt_params)
  }
  // 插件料 不焊接
  if (smt_params.is_plug == 0) {
    // 不焊接物料的插件孔可以上锡
    smt_params.is_assembly_weld_for_tin = 0
  }

  // 钢网 不焊接物料的贴片焊盘不开窗 不勾选
  if (smt_params.steel_no_tin_open == 1) {
    // 钢网加工要求
    smt_params.steel_remark = ''
    // 钢网加工要求附件地址
    smt_params.file_steel_url = ''
    // 钢网加工要求附件名称
    smt_params.file_steel_name = ''
  }
  // 钢网 普通钢网
  if (smt_params.steel_type == 0) {
    // 阶梯钢网器件位号
    smt_params.steel_position = ''
  }

  // 三防漆 不需要
  if (smt_params.need_conformal_coating == 0) {
    // 规避焊点及测试点
    smt_params.is_dodge_solder_joint = 0
  }
  // 三防漆 不需要 || 规避焊点及测试点 不勾选
  if (smt_params.need_conformal_coating == 0 || smt_params.is_dodge_solder_joint == 0) {
    // 三防漆加工要求
    smt_params.need_conformal_coating_remark =''
    // 三防漆加工要求附件地址
    smt_params.file_conformal_url = ''
    // 三防漆加工要求附件名称
    smt_params.file_conformal_name = ''
  }


  // 判断PCB和BOM是不是客供 客供提供数量
  if (smt_params.buy_bom == 2) {
    smt_params.bom_cus_material_num = smt_params.bom_material_type_number
  } else if (smt_params.buy_bom == 1) {
    // 华秋选项设置为0
    smt_params.bom_cus_material_num = 0  
  }
  if (smt_params.custom_pcb_ban == 3) {
    smt_params.pcb_cus_material_num = 1
  } else {
    smt_params.pcb_cus_material_num = 0
  }
 
  // 将 order_info, address, invoice 提取到与 smt_params 同级
  return {
    order_info,
    address,
    invoice,
    smt_params,
    ...(smt_params.custom_pcb_ban == 2 ? { pcb_params } : {})
  }
}

// SMT计价页下单校验
export const validateSmtQuote = (params,pcbParams,pcbNumber) => {
  // PCB全贴数量
  if (params.number_for_pcb || params.number_for_pcb === 0) {
    params.number = params.number_for_pcb
  }
  const number_type = params.number_type
  const valids = [
    { 
      key: 'is_develop_order',
      flag: params.is_develop_order === '' || params.is_develop_order === null || params.is_develop_order === undefined, 
      tips: '请选择订单类型'
    },
    { 
      key: 'application_sphere',
      flag: !params.application_sphere, 
      tips: '请选择产品领域'
    },
    { 
      key: 'custom_pcb_ban',
      flag: !params.custom_pcb_ban, 
      tips: '请选择PCB'
    },
    { 
      key: 'custom_pcb_ban',
      flag: params.custom_pcb_ban == 2 && (!params.pcbParams || !params.pcbParams.order_id), 
      tips: '请选择并确认PCB订单'
    },
    { 
      key: 'custom_pcb_ban',
      flag: params.custom_pcb_ban != 2 && !params.file_pcb, 
      tips: '请上传PCB文件'
    },
    { 
      key: 'buy_bom',
      flag: !params.buy_bom, 
      tips: '请选择BOM物料'
    },
    { 
      key: 'buy_bom',
      flag: params.buy_bom == 3 && (!params.order_info || !params.order_info.bom_id), 
      tips: '请选择并确认BOM订单'
    },
    { 
      key: 'buy_bom',
      flag: [1, 2, 4].includes(params.buy_bom) && !params.file_bom, 
      tips: '请上传BOM文件'
    },
    { 
      key: 'buy_bom',
      flag: !params.file_patch, 
      tips: '请上传坐标文件'
    },
    { 
      key: 'number',
      flag: !params.number && !params.number_for_pcb, 
      tips: '请输入生产数量'
    },
    { 
      key: 'number',
      flag: () => pcbNumber && (+pcbNumber < +params.number)&&+number_type===0&&isShowSmtParams(params,pcbParams).number_type,
      tips: 'SMT的生产数量不能大于pcb数量'
    },
    { 
      key: 'pcb_ban_num',
      flag: params.custom_pcb_ban == 3 && (!params.pcb_ban_x || !params.pcb_ban_y), 
      tips: '请填写PCB拼板规则'
    },
    { 
      key: 'pcb_ban_size',
      flag: params.custom_pcb_ban == 3 && (!params.pcb_ban_width || !params.pcb_ban_height), 
      tips: '请填写PCB拼板尺寸'
    },
    { 
      key: 'pcb_ban_size',
      flag: () => { 
        const [minVal, maxVal] = [params.pcb_ban_width, params.pcb_ban_height].sort((a, b) => a - b)
        return params.custom_pcb_ban == 3 && (minVal < 5 || maxVal < 5 || minVal > 46 || maxVal > 49)
      }, 
      tips: 'PCB拼板尺寸不能小于5cm，长边不能大于49cm，短边不能大于46cm',
    },
    { 
      key: 'bom_material_type_number',
      flag: !params.bom_material_type_number, 
      tips: '请填写BOM物料'
    },
    { 
      key: 'steel_type',
      flag: params.steel_type == 1 && !params.steel_position, 
      tips: '请填写需要做阶梯的器件位号'
    },
    { 
      key: 'need_conformal_coating',
      flag: params.need_conformal_coating != 0 && params.is_dodge_solder_joint == 1 && !params.need_conformal_coating_remark, 
      tips: '请填写三防漆加工要求'
    },
    { 
      key: 'solder_paste_type',
      flag: !params.solder_paste_type, 
      tips: '请选择制程要求'
    },
    { 
      key: 'x_ray',
      flag: !params.x_ray_number && params.x_ray_unit_number || params.x_ray_number && !params.x_ray_unit_number, 
      tips: 'X-RAY的元件数量与单板数量需同时为空或同时为0，或同时大于0' 
    },
    { 
      key: 'x_ray',
      flag: params.x_ray_unit_number > params.number, 
      tips: 'X-RAY单板数量不能大于单板数量' 
    },
    { 
      key: 'is_first_confirm',
      flag: !params.is_first_confirm && params.is_first_confirm !== 0, 
      tips: '请选择样品图确认'
    },
  ]

  return valids.filter(item => {
    const flag = typeof item.flag === 'function' ? item.flag() : item.flag
    return flag
  })
}

// 快板免费加急活动提示
export const formatDeliveryTips = (activity = {}) => {
  const smtActivity = activity.smt || []
  const item = smtActivity.find(item => item.code === 'S10001')
  if (item) {
    const delivery = { 3: '免费12H加急', 4: '免费24H加急' }[item.type]
    return delivery ? `当前参数满足${delivery}活动，最终实际生产周期以审核为准` : ''
  }
  return ''
}
